import firebase from '@firebase/app'
import '@firebase/database'

const state = {
  taskProgress: [],
  taskProgressRef: null,
  taskProgressLoaded: false
}

const getters = {
  taskProgress (state) {
    return state.taskProgress
  },
  taskProgressRef (state) {
    return state.taskProgressRef
  },
  taskProgressLoaded (state) {
    return state.taskProgressLoaded
  },
  taskProgressByKey (state) {
    return (taskProgressKey) => {
      return state.taskProgress.find(p => {
        return p.key === taskProgressKey
      })
    }
  },
  taskProgressByTaskByProgress (state) {
    return (taskKey, progressKey) => {
      return state.taskProgress.find(p => {
        return (p.taskKey === taskKey) && (p.progressKey === progressKey)
      })
    }
  },
  testAttempts (state) {
    return (taskKey, progressKey) => {
      let attempts = []
      for (let t of state.taskProgress) {
        if (t.taskKey === taskKey && t.progressKey === progressKey && t.endTime) attempts.push(t)
      }
      return attempts
    }
  }
}

const mutations = {
  setTaskProgress (state, payload) {
    state.taskProgress = payload
  },
  setTaskProgressRef (state, payload) {
    state.taskProgressRef = payload
  },
  setTaskProgressLoaded (state, payload) {
    state.taskProgressLoaded = payload
  }
}

const actions = {
  loadTaskProgress: (store, payload) => new Promise((resolve, reject) => {
    const ref = firebase.database().ref('taskProgress').child(payload)
    ref.on('value', snapshot => {
      const taskProgress = []
      snapshot.forEach(p => {
        taskProgress.push({key: p.key, ...p.val()})
      })
      store.commit('setTaskProgress', taskProgress)
      store.commit('setTaskProgressRef', ref)
      store.commit('setTaskProgressLoaded', true)
      resolve()
    })
  }),
  createTaskProgress: (store, payload) => new Promise((resolve, reject) => {
    const newTaskProgress = {...payload}
    store.getters.taskProgressRef.push(newTaskProgress).then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  }),
  updateTaskProgress: (store, payload) => new Promise((resolve, reject) => {
    const newTaskProgress = {...payload}
    store.getters.taskProgressRef.child(newTaskProgress.key).set(newTaskProgress).then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  }),
  resetTaskProgress: (store) => new Promise((resolve, reject) => {
    if (store.getters.taskProgressRef) store.getters.taskProgressRef.off()
    store.commit('setTaskProgress', [])
    store.commit('setTaskProgressRef', null)
    store.commit('setTaskProgressLoaded', false)
    resolve()
  })
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/student/taskProgress.js